import { render, staticRenderFns } from "./Diagnostics.vue?vue&type=template&id=005fb942&scoped=true&"
import script from "./Diagnostics.vue?vue&type=script&lang=js&"
export * from "./Diagnostics.vue?vue&type=script&lang=js&"
import style0 from "./Diagnostics.vue?vue&type=style&index=0&id=005fb942&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005fb942",
  null
  
)

export default component.exports